import $ from 'jquery';

import { addClassHandler, hlsConfig, accessClickHandler } from './utils';
import scrollSnapPolyfill from 'css-scroll-snap-polyfill';
import Draggabilly from 'draggabilly';
import simplebar from 'simplebar';

// scrollSnapPolyfill
scrollSnapPolyfill();

/////// Draggable
try {
	var draggie = new Draggabilly('.draggable', {
		// options
		containment: 'html'
	});

	if (localStorage.getItem('xCoor') && localStorage.getItem('yCoor')) {
		// draggie.startPosition.x = localStorage.getItem('xCoor');
		// draggie.startPosition.y = localStorage.getItem('yCoor');

		draggie.setPosition(localStorage.getItem('xCoor'), localStorage.getItem('yCoor'));
	}

	console.log(draggie);
} catch (err) {
	console.log(err);
}

//////////////////////////
$('.site-header__menu-toggler, .site-header__info').on('click', function(evt) {
	evt.preventDefault();

	addClassHandler($(this), 'site-header__menu-toggler');
});

try {
	$('.news-and-live').append($('.live'));
} catch (err) {
	console.log(err);
}

//////////////////////////////
try {
	const $newsTogglers = $('.news__toggler');
	$newsTogglers.on('click', (evt) => {
		evt.preventDefault();

		$newsTogglers.toggleClass('news__toggler--opened');
	});
} catch (err) {
	console.log(err);
}
//////////////////////////////////////////////////
/* replace img to iframe on video-details page */
let isFrameAdded = false;
$('.details__img-wrapper').on('click', function(evt) {
	evt.preventDefault();

	if ($(this).data('video') && !isFrameAdded) {
		const $this = $(this),
			$imgHeight = $this.find('img').height();

		$this.empty().append($this.data('video'));
		// $this.empty().append($this.data('video')).find('iframe').height($imgHeight);
		// console.log($this.find('iframe').attr('height', $imgHeight));
		isFrameAdded = true;
	}
});

//////////////////
/* poor-vision */
try {
	///////////////////////////////
	/* poor-vision localStorage */
	if (localStorage.getItem('poorVision')) {
		$('html').addClass('poor-vision');
	}

	const weaklyButton = $('.site-header__weakly');
	weaklyButton.on('click', (evt) => {
		evt.preventDefault();

		$('html').toggleClass('poor-vision');

		if (!!localStorage.getItem('poorVision')) {
			localStorage.removeItem('poorVision');
		} else {
			localStorage.setItem('poorVision', 'true');
		}
	});
} catch (err) {
	console.log(err);
}

//////////////////////////////
/* live-video play handler */
try {
	///////////////////////////////
	const video = document.querySelector('.live-video');
	const liveStreaming = $('.live-streaming');
	var=video_init = false;$('.live-streaming__play-button').on('click', function() {
		if (video_init === false) {try {
	if ($(window).width() >= 768) {
		hlsConfig('videoMainPage', 'http://live.1tvcrimea.ru:8080/switcher.m3u8');video_init = true;
	}
} catch (err) {
	console.log(err);
}}
		if (video.paused) {
			video
				.play()
				.then(() => console.log('Video Played'))
				.catch((err) => console.error('Video Cant Played', err));
			liveStreaming.addClass('played');
		} else {
			video.pause();
			liveStreaming.removeClass('played');
		}
	});

	/////////////////////////////
	const streamIncreaseButton = $('.live-streaming__increase-button');
	streamIncreaseButton.on('click', () => {
		liveStreaming.toggleClass('live-streaming--increased');
	});

	///////////////////////////
	const streamSoundButton = $('.live-streaming__sound-button');
	streamSoundButton.on('click', () => {
		liveStreaming.toggleClass('sound-on');
		video.muted = !video.muted;
	});
} catch (err) {
	console.log(err);
}

///////////////////////
/* hls plugin using */


try {
	hlsConfig('broadcastingVideo', 'http://mr2live.1tvcrimea.ru:8080/24tvcrimea.m3u8');
} catch (err) {
	console.log(err);
}

////////////////////////////////////////
/* Show two days -> teleprogram page */
try {
	const teleprogramButtons = $('.teleprogram__buttons-wrapper');

	teleprogramButtons.on('click', (evt) => {
		evt.preventDefault();

		$(evt.target)
			.addClass('teleprogram__button--checked')
			.siblings()
			.removeClass('teleprogram__button--checked')
			.parents('.teleprogram__wrapper')
			.attr('data-shows', $(evt.target).data('teleprogram'));
	});
} catch (err) {}

////////////////////////////////////////
/* Show tv-program for switched date */
try {
	const daysButtons = $('.teleprogram__days-button');

	daysButtons.on('click', function(evt) {
		const $this = $(this),
			dayItemIndex = $this.parent().index(),
			scheduleItem = $('.schedule')[dayItemIndex];

		$(scheduleItem).addClass('schedule--current').siblings().removeClass('schedule--current');
	});
} catch (err) {
	console.log(err);
}

///////////////////////////////////////
try {
	const accessFont = $('.access__fontsize-item'),
		accessColor = $('.access__color'),
		accessImagesToggle = $('.access__imagesoff');

	const accessFontClasses = [ 'fontsize-small', 'fontsize-normal', 'fontsize-big' ];
	const accessColorClasses = [ 'color1', 'color2', 'color3' ];

	accessFont.on('click', function(evt) {
		evt.preventDefault();

		const $this = $(this);

		accessClickHandler($this, 'access__fontsize-item--current', accessFontClasses);
	});
	accessColor.on('click', function(evt) {
		evt.preventDefault();

		const $this = $(this);

		accessClickHandler($this, 'access__color--current', accessColorClasses);
	});

	accessImagesToggle.on('click', function(evt) {
		evt.preventDefault();

		$html.toggleClass('imagesoff');
	});
} catch (err) {
	console.log(err);
}

try {
	$('.details__article').append($('.details > .ya-share2'));
} catch (error) {
	console.log(error);
}

/////////////////////////////////
// WRITE DragPosition to localStorage
function listener(event, pointer) {
	// console.log(event);
	console.log(this.position.x, this.position.y);

	localStorage.setItem('xCoor', this.position.x);
	localStorage.setItem('yCoor', this.position.y);

	console.log(draggie);
}

draggie.on('dragEnd', listener);
